import script from "./ApplicationResultCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationResultCard.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/search-page/search-page-dashboard.css?vue&type=style&index=0&id=0a1f5174&scoped=true&lang=css&external"
import "@/assets/css/search-page/application-card.css?vue&type=style&index=1&id=0a1f5174&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1f5174"]])

export default __exports__